import { useEffect } from 'react';
import { useWtrSelector } from 'redux/hooks';
import usePrevious from 'hooks/use-previous';
import { getCustomerSlotBranchId } from 'redux/modules/customer-slot/selectors';

const NO_BRANCH = 'no_branch';

export const useOnBranchChange = (onChange: () => void) => {
  const customerSlotBranchId = useWtrSelector(getCustomerSlotBranchId);
  const branchId = customerSlotBranchId ?? NO_BRANCH;
  const previousCustomerSlotBranchId = usePrevious(branchId);

  useEffect(() => {
    if (previousCustomerSlotBranchId && previousCustomerSlotBranchId !== branchId) {
      onChange();
    }
  }, [previousCustomerSlotBranchId, branchId, onChange]);
};
